import {ID} from '@wandb/weave/common/util/id';
import {type Editor, Transforms} from 'slate';

import {ArtifactVersionsGridElement} from '../../PanelArtifactVersionMetrics/ArtifactVersionsGridElement';
import {
  ARTIFACT_VERSIONS_GRID_TYPE,
  type ArtifactVersionsGrid,
  type ArtifactVersionsGridMetadata,
  createArtifactVersionsGridMetadata,
  isArtifactVersionsGrid,
} from '../../PanelArtifactVersionMetrics/artifactVersionsGridTypes';

export {
  ARTIFACT_VERSIONS_GRID_TYPE,
  ArtifactVersionsGridElement,
  createArtifactVersionsGridMetadata,
  isArtifactVersionsGrid,
};
export type {ArtifactVersionsGrid, ArtifactVersionsGridMetadata};

export const withArtifactVersionsGrids = <T extends Editor>(editor: T) => {
  const {isVoid, normalizeNode} = editor;

  editor.isVoid = element => {
    return isArtifactVersionsGrid(element) ? true : isVoid(element);
  };

  editor.normalizeNode = entry => {
    const [node, path] = entry;

    if (isArtifactVersionsGrid(node) && node.metadata.gridId == null) {
      Transforms.setNodes(
        editor,
        {
          metadata: {
            ...node.metadata,
            gridId: ID(),
          },
        },
        {at: path}
      );
      return;
    }

    normalizeNode(entry);
  };

  return editor;
};
